export const themeConfig = {
  appLogoImage: null,
  titleBarLogo: "/logo.png",
  logoText: "SmartPantryPal",
  appName: "SmartPantryPal",
  primaryColor: "#2D5A3D",
  primaryColorLight: "rgba(0, 0, 0, 0.4)",
  secondaryColor: "#fff",
  errorColor: "#ff4d4f",
  fontFamily: "montserrat",
  sidebarTheme: "light", // "light" or "dark"
};
